var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 7.75,
    fill: "url(#paint0_linear_1130_9762)",
    stroke: "#e6e6e6",
    strokeWidth: 0.5,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5C21.933 18.5 23.5 16.933 23.5 15C23.5 13.067 21.933 11.5 20 11.5C18.067 11.5 16.5 13.067 16.5 15C16.5 16.933 18.067 18.5 20 18.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2465 26.5202C11.974 27.5907 12.8951 28.5 13.9997 28.5H25.9997C27.1043 28.5 28.0254 27.5907 27.7529 26.5202C26.8718 23.0595 23.7347 20.5 19.9997 20.5C16.2647 20.5 13.1276 23.0595 12.2465 26.5202Z",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1130_9762",
    x1: 1.47849,
    y1: 20,
    x2: 40.0806,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserIcon);
export default __webpack_public_path__ + "static/media/DefaultUserIcon.3c16a56eede866122f2d6221b8e26421.svg";
export { ForwardRef as ReactComponent };